import { useCustomerAppConfig } from "undercarriage";

export const useOfferRequestPath = () => {
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const getPublishedOffers = (productRequestId?: string | null): string => {
    return `/${customerDomain}/offers/api/product-request/${productRequestId}/published-offers`;
  };

  const getCustomOfferDetails = (productRequestId: string, customOfferId: number): string => {
    return `/${customerDomain}/offers/api/product-request/${productRequestId}/custom-offer/${customOfferId}`;
  };

  const getSampleOfferMca = (advanceId?: number | null): string => {
    return `/${customerDomain}/financing/api/advance/${advanceId}/summary`;
  };

  const selectSampleOffer = (productRequestId: string, offerId: number): string => {
    return `/${customerDomain}/offers/api/product-request/${productRequestId}/sample-offer/${offerId}`;
  };

  const selectCustomOffer = (productRequestId: string, offerId: number): string => {
    return `/${customerDomain}/product-request/api/${productRequestId}/custom-offer/${offerId}`;
  };

  const changeSelectedSampleOffer = (productRequestId: string): string => {
    return `/${customerDomain}/product-request/api/${productRequestId}/selected-offer`;
  };

  const getDealOwner = (productRequestId: string) => {
    return `/${customerDomain}/offers/api/product-request/${productRequestId}/deal-owner`;
  };

  const getCollectionSchedule = () => {
    return `/${customerDomain}/financing/api/advances/collection-schedule`;
  };

  const getCollectionScheduleCsv = () => {
    return `/${customerDomain}/financing/api/advances/collection-schedule/csv`;
  };

  const requestNewOffers = (productRequestId: string): string => {
    return `/${customerDomain}/product-request/${productRequestId}/request-new-offers`;
  };

  const viewCustomerRoot = (): string => {
    return `/${customerDomain}/`;
  };

  const viewCustomerContractReview = (): string => {
    return `/${customerDomain}/financing/funds-request/contracts/review`;
  };

  const viewCustomerAdvanceDetail = (advanceId?: number | null): string => {
    return `/${customerDomain}/financing/advances?id=${advanceId}`;
  };

  const viewOrderForm = (): string => {
    return `/${customerDomain}/financing-contract-order-form`;
  };

  return {
    getPublishedOffers,
    getCustomOfferDetails,
    getSampleOfferMca,
    selectSampleOffer,
    selectCustomOffer,
    changeSelectedSampleOffer,
    getDealOwner,
    getCollectionSchedule,
    getCollectionScheduleCsv,
    requestNewOffers,
    viewCustomerRoot,
    viewCustomerContractReview,
    viewCustomerAdvanceDetail,
    viewOrderForm,
  };
};
